import React from "reactn";
import styled from "styled-components";
import { Button, Icon } from "@material-ui/core";
import { _ } from "../../../../../vendor";

const ActionButton = styled(Button)`
  background-color: rgba(0,0,0,.05) !important;
  font-size: 13px !important;
  color: #777 !important;
`;

const Container = styled.div`
    display: grid;
    grid-auto-flow: column;
    grid-auto-columns: max-content;
    justify-content: center;
    gap: 10px;
    margin-right: 10px;
`;

const shortCuts = [
    {
        action: "list",
        icon: "list",
        name: "Lists"
    },
    {
        action: "structure",
        icon: "star",
        name: "Structure"
    },
    {
        action: "data",
        icon: "trending_up",
        name: "Data & Charts"
    },
    {
        action: "impact",
        icon: "camera",
        name: "Visual Impact"
    },
    {
        action: "diagram",
        icon: "widgets",
        name: "Diagrams"
    },
    {
        action: "comparison",
        icon: "view_column",
        name: "Comparison"
    },
    {
        action: "people",
        icon: "face",
        name: "People"
    },
];

export function SearchShortCuts({ handleShortCut, selectedShortCut }) {
    return (
        <Container>
            {
                shortCuts.map(shortCut => {
                    return (
                        <ActionButton key={_.uniqueId()} onClick={() => handleShortCut(shortCut.action)}>
                            {shortCut.name}
                        </ActionButton>
                    );
                })
            }
        </Container>
    );
}
